import { render } from "./SpeechRecognition.vue?vue&type=template&id=22b8644c&scoped=true"
import script from "./SpeechRecognition.vue?vue&type=script&lang=js"
export * from "./SpeechRecognition.vue?vue&type=script&lang=js"

import "./SpeechRecognition.vue?vue&type=style&index=0&id=22b8644c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b8644c"]])

export default __exports__